/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateAccountEmail.defs'
export { main as default } from './updateAccountEmail.defs'
